// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"323":"9f892290","784":"7f4e0d85","942":"6ff0f168"}[chunkId] + ".chunk.css";
};